import { useCallback, useMemo } from 'react';

import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import { WDAC_CATALOG_INVENTORY_QUERY_KEY } from 'src/constants/query';
import { EXPANDED_ROWS_LIMIT } from 'src/constants/table';
import useSubscribeStorage from 'src/hooks/useSubscribeStorage';
import useInfiniteFetch from 'src/queries/useInfiniteFetch';
import useQueryParams from 'src/hooks/useQueryParams';
import { parseQueryToApiQuery } from 'src/utils/query.utils';
import CatalogInventoryService from '../../../../services/catalog-inventory.service';

const useFetchWDACCatalogInventory = () => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  const {
    queryObject: { searchValue: initialSearchValue, filters = {} },
  } = useQueryParams();

  const query = useMemo(
    () =>
      parseQueryToApiQuery({
        filters,
        searchValue: initialSearchValue,
      }),
    [filters, initialSearchValue],
  );

  const fetchFunction = useCallback(
    ({ page, limit }) =>
      CatalogInventoryService.getCatalogInventoryAll({
        limit,
        page,
        customerEnvId,
        query,
      }),
    [customerEnvId, query],
  );

  const response = useInfiniteFetch({
    queryKey: [WDAC_CATALOG_INVENTORY_QUERY_KEY, query, customerEnvId],
    fetchFunction,
    expandedRowsLimit: EXPANDED_ROWS_LIMIT,
    itemName: 'catalogInventories',
  });

  return {
    ...response,
    query,
  };
};

export default useFetchWDACCatalogInventory;
